import { palette } from '../global/palette';

export const MuiProgressIndicators = {
  MuiLinearProgress: {
    styleOverrides: {
      root: {
        backgroundColor: palette.info.contrastText,
        borderRadius: '2px',
      },
      barColorPrimary: {
        backgroundColor: palette.primary.main,
        borderRadius: '2px',
      },
    },
  },
  MuiCircularProgress: {
    styleOverrides: {
      colorPrimary: {
        color: palette.primary.main,
      },
    },
  },
};
